module.exports = __webpack_public_path__ + "static/media/fk.5fded405.webp";